<template>
  <div class="tab-pane fade show active" id="nav-5-3-primary-ver--1" role="tabpanel">
        <span v-on:click="toggleCollapse(collapseStatus)" class="pull-right" style=""><a class="g-font-size-12" v-if="collapseStatus == false">Expand All </a><a class="g-font-size-12" v-if="collapseStatus == true">Collapse All</a></span>
        <!-- Accordion -->
        <h3 class="g-color-main">{{ section }}</h3>
        <div style="background-color: #26304d; height: 3px; margin-bottom: 10px"></div>
        <div v-for="(group, index) in groups" id="accordion-12-1" class="u-accordion u-accordion-color-primary" role="tablist" aria-multiselectable="true">
            <!-- Card -->
            <div class="card g-brd-none rounded-0" :class="{'g-bg-secondary': ((index % 2) == 1)}">
            <div id="accordion-12-1-heading-01" class="u-accordion__header g-color-text g-font-weight-500" role="tab">
                <h5 class="g-font-size-20 mb-0">
                <a v-on:click="changeCollapse(group)" class="d-block g-color-text g-color-primary--hover g-font-size-20--md g-font-size-17 g-text-underline--none--hover g-pa-12"  data-toggle="collapse" data-parent="#accordion-12-1" aria-expanded="true" aria-controls="accordion-12-1-body-01">
                    {{group.name}}
                </a>
                </h5>
            </div>
            <div v-show="group.open" id="accordion-12-1-body-01" class="collapsed show" role="tabpanel" aria-labelledby="accordion-12-1-heading-01">
                <div class="u-accordion__body g-color-text g-pa-30 g-pt-0">
                <span class="g-font-size-20--md g-font-size-17" v-html="group.items"></span> 
                </div>
            </div>
            </div>
            <!-- End Card -->
        </div>
        <!-- End Accordion -->
    </div>
</template>
<script>
export default {
    props: ["section", "items"],
    data () {
    return {
        collapseStatus: false,
        groups: []
    }
    },
    created() {
        //console.log("In HelpItem");
        //console.log(this.items);
        let g = Array.from(this.items).map(x => {
            //console.log(x);
            return {
                "name": x.title,
                "open": false,
                "items": x.description
            };
        });
        //console.log(g);

//        let mapped = g.
        this.groups = g;
    },
    methods: {
        toggleCollapse(collapseStatus) {
            this.collapseStatus = !this.collapseStatus;
            this.groups.forEach(element => {
                element.open = this.collapseStatus;
            });
        },
        changeCollapse(group) {
            this.groups.forEach(element => {
                element.open = false;
            });
            group.open = true;
        }
    }
}
</script>



// WEBPACK FOOTER //
// HelpItem.vue?e5fce3cc